// Author LiangGangQiang
// Date 2021-12-08 14:56:39

class SithMesPrdPpHeaderInfoModifyOwner {
constructor({
        id = null,
        code = '',
        name = '',
        bakTitle = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.bakTitle = bakTitle;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdPpHeaderInfoModifyOwner();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyOwner.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyOwner.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyOwner.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyOwner.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    nameFilter : '',
    bakTitleFilter : '',
    seqFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyOwner.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyOwner.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyOwner.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyOwner.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyOwner.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdPpHeaderInfoModifyOwner, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
